import React from 'react';

function ContactUs() {
  return (
    <div>
      <h2>Contact Us</h2>
      <p>
        If you have any questions, feel free to reach out to us at{' '}
        <span style={{ fontWeight: 'bold' }}>ammucraftarts@gmail.com</span>!
      </p>
    </div>
  );
}

export default ContactUs;
